import Call from '../Call';

const AdkCountryHourFactor = {
    get() {
        return Call(`adkCountryHourFactor`);
    },

    save(factors) {
        return Call('adkCountryHourFactor','POST', { factors });
    },

    sync() {
        return Call(`adkCountryHourFactor/sync`);
    }
};

export default AdkCountryHourFactor;



// WEBPACK FOOTER //
// ./src/services/API/components/AdkCountryHourFactor.js